module.exports = "/assets/site/images/tomegsport_gyongyos.jpg?01766b70a51c94fffdba71b2067d7d02";